import React from 'react';
import Icon from '@components/atoms/icon';

type SearchInputType = {
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | React.ReactNode;
  type?: string;
  pattern?: string;
  id?: string;
  placeholder?: string;
  onClose: () => void;
  showCloseIcon: boolean;
  inputClasses?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
  autoFocus?: boolean;
  showSearchIcon: boolean;
};

const SearchInput = ({
  value,
  handleChange,
  label,
  type = 'text',
  pattern,
  id,
  placeholder,
  onClose,
  showCloseIcon,
  inputClasses,
  onKeyDown,
  autoFocus,
  showSearchIcon
}: SearchInputType) => (
  <div className="w-full searchInput">
    <label htmlFor="search" className="text-base text-neutral-800 flex mb-1">
      {label}
    </label>
    <div className="relative mb-0 mr-2">
      {showSearchIcon && (
        <div className="absolute inset-y-0 left-0 flex items-center justify-center pl-2 pointer-events-none">
          <span>
            <Icon
              name={'Search'}
              style={{ fontSize: '16px', marginBottom: '2px' }}
            />
          </span>
        </div>
      )}
      <input
        id={id}
        name={id}
        autoComplete="off"
        className={`block w-full ${
          showSearchIcon ? 'pl-7' : 'pl-3'
        } pr-3 px-3 py-2 border border-neutral-300 rounded-lg placeholder-neutral-600 rounded-lg focus:outline-1 border-1 focus:border-primary-600 bg-white ${inputClasses} `}
        onChange={(e) => handleChange(e)}
        value={value}
        placeholder={placeholder}
        type={type}
        pattern={pattern}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
      />
      {showCloseIcon && (
        <Icon name={'Cancel'} onClick={onClose} className="cancelIcon" />
      )}
    </div>
  </div>
);

export default SearchInput;
